// angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
// libs
import { RouterExtensions } from '@luggagehero/core';
import { ManageShopsBaseComponent } from '@luggagehero/features/shop-manager';
import { StorageManagerService } from '@luggagehero/services';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';

@Component({
  selector: 'lh-manage-shops',
  templateUrl: 'manage-shops.component.html',
  styleUrls: ['manage-shops.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageShopsComponent extends ManageShopsBaseComponent {
  constructor(
    storageManagerService: StorageManagerService,
    userService: SharedUserService,
    router: RouterExtensions,
    cd: ChangeDetectorRef,
    sharedStorageService: SharedStorageService,
  ) {
    super(storageManagerService, userService, router, cd, sharedStorageService);
  }
}
